// extracted by mini-css-extract-plugin
export default {"header":"header__header___eWH69","logoWrapper":"header__logoWrapper___BRHDd","logo":"header__logo___jaKK3","logoEn":"header__logoEn___XrvFe"};